import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import React from 'react';
export const StatusSlot = _ref => {
  let {
    emptyQueryStatus
  } = _ref;
  if (emptyQueryStatus) {
    return /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.EmptyQueryStatus, null);
  }

  // A submitted domain that resolves to no action surfaces as the NO_STATUS
  // status; consumers render it via statusesCustomComponents[NO_STATUS].
  return /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.Status, null);
};
//# sourceMappingURL=StatusSlot.js.map